import { render, staticRenderFns } from "./ResultMore.vue?vue&type=template&id=0532f2a8&scoped=true&"
import script from "./ResultMore.vue?vue&type=script&lang=js&"
export * from "./ResultMore.vue?vue&type=script&lang=js&"
import style0 from "./ResultMore.vue?vue&type=style&index=0&id=0532f2a8&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0532f2a8",
  null
  
)

export default component.exports